import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "bootstrap";
import { useBasket } from "../utils/BasketContext";
import { useLanguage } from "../context/LanguageContext";
import MobileAccountPopup from "../popupPages/MobileAccountPopup";
import MobileEmptyCartPopup from "../popupPages/MobileEmptyCartPopup";
import "../styles/style.css";

interface Props {
  loggedIn: boolean;
  onLoginSuccess: () => void;
  onLogout: () => void;
}

function MobileBottomTabs({ loggedIn, onLoginSuccess, onLogout }: Props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { basketCount } = useBasket();
  const { t } = useLanguage();
  const [showAccount, setShowAccount] = useState(false);
  const [showEmptyCart, setShowEmptyCart] = useState(false);

  const openSepet = () => {
    if (basketCount === 0) {
      setShowEmptyCart(true);
      return;
    }
    const el = document.getElementById("sepetModal");
    if (el) {
      Modal.getOrCreateInstance(el).show();
    }
  };

  const isFood = pathname === "/";
  const isSearch = pathname === "/restaurants";

  return (
    <>
      <div className="mobile-bottom-tabs d-flex d-sm-none">
        <button
          className={`mobile-bottom-tabs__tab${isFood ? " mobile-bottom-tabs__tab--active" : ""}`}
          onClick={() => navigate("/")}
        >
          <i className="bi bi-egg-fried"></i>
          <span>{t("bottomTabs.food")}</span>
        </button>

        <button
          className={`mobile-bottom-tabs__tab${isSearch ? " mobile-bottom-tabs__tab--active" : ""}`}
          onClick={() => navigate("/restaurants")}
        >
          <i className="bi bi-search"></i>
          <span>{t("bottomTabs.search")}</span>
        </button>

        <button
          className="mobile-bottom-tabs__tab"
          onClick={openSepet}
        >
          <i className="bi bi-cart-fill"></i>
          {basketCount > 0 && (
            <span className="mobile-bottom-tabs__badge badge rounded-pill bg-danger text-white">
              {basketCount}
            </span>
          )}
          <span>{t("bottomTabs.cart")}</span>
        </button>

        <button
          className={`mobile-bottom-tabs__tab${showAccount ? " mobile-bottom-tabs__tab--active" : ""}`}
          onClick={() => setShowAccount(true)}
        >
          <i className={`bi ${showAccount ? "bi-person-fill" : "bi-person"}`}></i>
          <span>{t("bottomTabs.account")}</span>
        </button>
      </div>

      {showAccount && (
        <MobileAccountPopup
          onClose={() => setShowAccount(false)}
          loggedIn={loggedIn}
          onLoginSuccess={onLoginSuccess}
          onLogout={onLogout}
        />
      )}

      {showEmptyCart && (
        <MobileEmptyCartPopup onClose={() => setShowEmptyCart(false)} />
      )}
    </>
  );
}

export default MobileBottomTabs;
